import { UserStore } from '@/store/UserStore';
import { createContext } from 'react';

export const UserContext = createContext<UserStore>({} as any);
